// prefer default export if available
const preferDefault = m => m && m.default || m

exports.components = {
  "component---src-templates-event-detail-js": () => import("./../src/templates/event-detail.js" /* webpackChunkName: "component---src-templates-event-detail-js" */),
  "component---src-pages-404-js": () => import("./../src/pages/404.js" /* webpackChunkName: "component---src-pages-404-js" */),
  "component---src-pages-index-js": () => import("./../src/pages/index.js" /* webpackChunkName: "component---src-pages-index-js" */),
  "component---src-pages-subscribe-error-js": () => import("./../src/pages/subscribe-error.js" /* webpackChunkName: "component---src-pages-subscribe-error-js" */),
  "component---src-pages-subscribe-success-js": () => import("./../src/pages/subscribe-success.js" /* webpackChunkName: "component---src-pages-subscribe-success-js" */)
}

